export default __webpack_public_path__ + "static/media/rent-out-space1.98d004a6.png";